
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBuoyBarrelSquare as ObiBuoyBarrelSquareElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-buoy-barrel-square.js';
 
 
 

 
 export const ObiBuoyBarrelSquare = createComponent({
   react: React,
   tagName: 'obi-buoy-barrel-square',
   elementClass: ObiBuoyBarrelSquareElement,
   events: {
     
   }
  });
 
 